import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {isIframe} from "../../../../misc/helpers";
import {ROUTES} from "../../../../routes";
import {setShopPageOpened} from "../../../../actions/shopFunctions";


const GroheShopButton = (props) => {

  const {intl, setShopPageOpened, fabricatorData, history, shopLastPageVisited, topButtonClick} = props;

  const isLixil = isIframe() && fabricatorData.isLixil;
  if (isLixil || !fabricatorData.settings.checkout) {
    return null
  }

  const exitButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productTopButtonsShop);
    topButtonClick(false);
    setShopPageOpened(true);
    history.push(shopLastPageVisited || ROUTES.shop);
  }

  return (
    <div className={"gm-buttons__button"}>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.shop"})}
                  className="look-icon look-icon--small1 look-icon--grohe"
                  onClick={exitButtonClick}>
        <NavigateBeforeIcon/>
      </IconButton>
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  const {shopLastPageVisited} = store.shopState;

  return {
    fabricatorData,
    shopLastPageVisited,
  };
};

const mapDispatchToProps = {
  setShopPageOpened,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheShopButton)
  )
)
